export const MINIMUM_COUNTRY_LENGTH = 2
export const MAXIMUM_POSTCODE_LENGTH = 10
